import type { Module } from 'vuex';

/**
 * Nav: **Dashboard**. Not designed yet — the nav entry exists so the sidebar matches the mockup.
 *
 * Addresses as `crm/dashboard/<action>`, state at `state.crm.dashboard` (see store/index.ts).
 */
export interface DashboardState {
    loading: boolean;
    error: string | null;
}

const defaultState = (): DashboardState => ({
    loading: false,
    error: null,
});

export const dashboardModule: Module<DashboardState, unknown> = {
    namespaced: true,
    state: defaultState,
    mutations: {
        SET_LOADING(state: DashboardState, value: boolean): void {
            state.loading = value;
        },
        SET_ERROR(state: DashboardState, message: string | null): void {
            state.error = message;
        },
    },
    actions: {},
    getters: {
        loading: (state: DashboardState): boolean => state.loading,
        error: (state: DashboardState): string | null => state.error,
    },
};
